import axios from 'axios';

const API_BASE_URL = 'https://zenoapi.com/api';

const getAuthHeaders = () => {
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  const token = userData?.tokens?.access?.token;
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
};

const normalizeMessage = (msg) => ({
  id: msg.id,
  sender: msg.sender_type,
  senderName: msg.sender_name,
  message: msg.message,
  timestamp: msg.created_at,
});

const normalizeTicket = (ticket) => ({
  id: ticket.id,
  ticketNumber: ticket.ticket_number,
  userName: ticket.user_name,
  userEmail: ticket.user_email,
  subject: ticket.subject,
  category: ticket.category,
  description: ticket.description,
  priority: ticket.priority,
  status: ticket.status,
  createdAt: ticket.created_at,
  updatedAt: ticket.updated_at,
  messages: (ticket.messages || []).map(normalizeMessage),
});

export const createTicket = async ({ subject, category, description, priority }) => {
  const response = await axios.post(
    `${API_BASE_URL}/support/tickets/`,
    { subject, category, description, priority },
    { headers: getAuthHeaders() },
  );
  return normalizeTicket(response.data);
};

export const getUserTickets = async () => {
  const response = await axios.get(`${API_BASE_URL}/support/tickets/`, {
    headers: getAuthHeaders(),
  });
  return response.data.map(normalizeTicket);
};

export const getAllTickets = async ({ status, priority, search } = {}) => {
  const params = {};
  if (status && status !== 'All') params.status = status;
  if (priority && priority !== 'All') params.priority = priority;
  if (search) params.search = search;

  const response = await axios.get(`${API_BASE_URL}/support/admin/tickets/`, {
    headers: getAuthHeaders(),
    params,
  });
  return response.data.map(normalizeTicket);
};

export const getTicketById = async (id, asAdmin = false) => {
  const path = asAdmin ? `admin/tickets/${id}/` : `tickets/${id}/`;
  const response = await axios.get(`${API_BASE_URL}/support/${path}`, {
    headers: getAuthHeaders(),
  });
  return normalizeTicket(response.data);
};

export const addMessage = async (ticketId, message, asAdmin = false) => {
  const path = asAdmin
    ? `admin/tickets/${ticketId}/messages/`
    : `tickets/${ticketId}/messages/`;
  const response = await axios.post(
    `${API_BASE_URL}/support/${path}`,
    { message },
    { headers: getAuthHeaders() },
  );
  return normalizeTicket(response.data);
};

export const getAISuggestedReply = async (ticketId) => {
  const response = await axios.post(
    `${API_BASE_URL}/support/admin/tickets/${ticketId}/ai-suggest-reply/`,
    {},
    { headers: getAuthHeaders() },
  );
  return response.data.suggested_reply;
};

export const setTicketStatus = async (ticketId, status) => {
  const response = await axios.patch(
    `${API_BASE_URL}/support/admin/tickets/${ticketId}/`,
    { status },
    { headers: getAuthHeaders() },
  );
  return normalizeTicket(response.data);
};

export const isAdminUser = () => {
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  const u = userData.user || {};
  return u.is_staff === true || u.is_superuser === true;
};
